import { Stack, Button, Center, Text, Box } from '@chakra-ui/react'
import { VideoCallRoom_VideoCallRoomReadyDocument } from 'src/lib/gql-client'
import { useGqlQuerySWRNoSuspense } from 'src/lib/gql-client/request'

import { useVideoCallRoom } from '../../context/videoCallRoomContext'

type Props = {
  colorScheme?: 'blue' | 'green'
  sendNotification?: () => void
}

export const VideoCallRoomReady: React.FC<Props> = ({
  colorScheme = 'blue',
  sendNotification,
}) => {
  const { join, videoCallRoomUid, proxyStatus, agoraCloudProxyMode } =
    useVideoCallRoom()

  const { data: videoCallRoom } = useGqlQuerySWRNoSuspense(
    VideoCallRoom_VideoCallRoomReadyDocument,
    videoCallRoomUid ? { videoCallRoomUid } : null,
    {
      refreshInterval: 5000,
    },
  )

  const started = (videoCallRoom?.videoCallRoom.joinedMemberCount ?? 0) > 0

  const message = started
    ? '通話が開始されています'
    : '通話はまだ開始されていません'

  // Cloud Proxyモードを使用している場合は、proxy serverの準備完了を待つ
  const isButtonDisabled =
    agoraCloudProxyMode !== 'Auto' && proxyStatus !== 'connected'

  return (
    <Center w="full" h="full">
      <Stack spacing="6" align="center">
        <Text color="white" fontSize="2xl" fontWeight="bold">
          {message}
        </Text>
        <Box>
          <Button
            colorScheme={colorScheme}
            isDisabled={isButtonDisabled}
            onClick={() => {
              if (!started && !!sendNotification) sendNotification()
              join()
            }}
          >
            {started ? '今すぐ通話を開始する' : '通話を開始する'}
          </Button>
        </Box>
      </Stack>
    </Center>
  )
}
